import React from "react";
import { NavLink } from "react-router-dom";
import { Nav, UncontrolledCollapse, Button } from "reactstrap";
import PerfectScrollbar from "perfect-scrollbar";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";

// helpers
import { getSessionCookie } from "helpers/cookies";

var ps;

class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.sidebar = React.createRef();    
  }
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.sidebar.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
    }
  }
  useName() {
    let session = getSessionCookie();  
    if (session != null)
      return session.nome;
  }
  render() {
    return (
      <div
        className="sidebar"
        data-color={this.props.bgColor}
        data-active-color={this.props.activeColor}
      >
        <div className="logo text-center" style={{minHeight: "60px"}}>
          <img className="mt-2" src={require("assets/img/logo-prefeitura.png")} style={{ maxHeight: "50px", width: "130px" }} alt="react-logo" />
        </div>
        <div className="logo mt-2">
          <div className="text-center bg-info"><label className="mt-2">Dashboard</label></div>
          <div className="mt-4 pl-4 text-white"><i className={"fas fa-user mr-2"} />&nbsp;&nbsp;<label>{this.useName()}</label></div>
        </div>
        <div className="sidebar-wrapper" ref={this.sidebar}>
          <Nav>
            {this.props.routes.map((prop, key) => {
              return (
                <li
                  className={
                    this.activeRoute(prop.path) +
                    (prop.pro ? " active-pro" : "")
                  }

                  Style={prop.sidebar == true ? "display: block" : "display: none"}

                  key={key}
                >
                  <NavLink
                    to={prop.layout + prop.path}
                    className="nav-link"
                    activeClassName="active"
                  >
                    <i className={prop.icon} />
                    <p>{prop.name}</p>
                  </NavLink>
                </li>
              );
            })}
          </Nav>
          <Container fluid>
            <footer className="footer">
              <Row className="text-center mt-4">
                <Col xl="12" className="mt-4">
                  <img
                    alt={"..."}
                    className="navbar-brand-img"
                    src={require("assets/img/SPRegula.png")}
                    width="180px"
                  />
                </Col>
              </Row>
            </footer>
          </Container>
        </div>

      </div>
    );
  }
}

export default Sidebar;
